// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".md-field{border-radius:5px}.error-text{color:red;font-size:12px;margin-bottom:0}.md-menu-content.md-select-menu{z-index:1000}.order-create-modal .cus-label{font-size:.8vw}@media screen and (max-width:800px){.order-create-modal .cus-label{font-size:3vw}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
